import { Checkbox, Dialog,
  //  EditIcon, 
   IconButton,TrashIcon, 
    Pane, Spinner, toaster, } from 'evergreen-ui'
import React, { useRef, useState, } from 'react'
import { FieldBtn, FieldBtnDelete } from '../../dues/dues.style'
import { AppInputField, AppInputFieldBtn, AppInputFieldBtnCancel, InputFieldTitleText } from '../../../../../widget/styledComponents/input_field.style'
import Cookies from 'js-cookie' 
import { gql, useMutation, useQuery } from '@apollo/client';
import { 
  TableHead,
  TableBodyRow
} from '../../../../../widget/styledComponents/table.style'
import { capitalizeFirstLetterOfWords } from '../../../../../widget/util'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'


export const PROPERTYSEARCHBYRESIDENT= gql`
query Properties_searchByAddressAndResidentName($searchTerm: String!, $facilityId: ID!) {
  properties_searchByAddressAndResidentName(searchTerm: $searchTerm, facilityId: $facilityId) {
    _id
    facility
    type
    address
    numberOfRooms
    squareMeter
    createdAt
    owner {
      _id
      id
      email
      name
      phone
      photo
      facility
      isAccountActivated
      savedCards {
        _id
        expMonth
        maskedPan
        expYear
        isPrimary
      }
      createdAt
    }
    resident {
      _id
      email
      name
      phone
      photo
      facility
      savedCards {
        _id
        expMonth
        maskedPan
        expYear
        isPrimary
      }
      id
      isAccountActivated
      createdAt
    }
    tags {
      name
      value
    }
  }
}
`;


export const FETCH_RESIDENT_LIST = gql`
query Properties_getByFacility($facilityId: ID!, $pagination: PaginationInput!) {
  properties_getByFacility(facilityId: $facilityId, pagination: $pagination) {
    resident {
      _id
      email
      name
      phone
      photo
      facility
      savedCards {
        _id
        expMonth
        maskedPan
        expYear
        isPrimary
      }
      id
      isAccountActivated
      createdAt
    }
  }
}
`;


function PropertyResident(props) {
const details = props.details
const resident = details.resident
console.log("resident",details)
  return (
    <div>
        <table className='responsive-table'>
          <thead>
          <tr
          >
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Phone No</TableHead>
              <TableHead>Action</TableHead>

          </tr>
          </thead>

          <tbody>
              {/* {loading && <Spinner/> } */}
              

              {resident &&     
              <TableBodyRow key={resident._id} isSelectable onSelect={() => console.log("d")}>
                  <td>{resident.name}</td>
                  <td>{resident.email}</td>
                  <td>{resident.phone}</td>
                  <td>
                  <Pane display="flex" alignItems="center">
                    {/* <IconButton icon={EditIcon}  /> */}
                   
                    <DeleteResidentIconBtn propertyId={details._id} residentId={resident._id}/>
                  </Pane>
                  </td>
              </TableBodyRow>
              }
          </tbody>
      </table>
        {/* <Pagination className='transparent z-depth-0' page={1} totalPages={3}></Pagination>    */}
        <div className='row mt-25'>
            <div className='col s12 center'>
                <AddResidentBtn id={details._id}/>
            </div>
        </div>
                  
    </div>
  )
}

export default PropertyResident




export const ADD_RESIDENT = gql`
mutation Property_addResident($propertyId: ID!, $isExistingResident: Boolean!, $existingResidentId: ID, $name: String, $email: String, $phone: String) {
  property_addResident(propertyId: $propertyId, isExistingResident: $isExistingResident, existingResidentId: $existingResidentId, name: $name, email: $email, phone: $phone) {
    code
    success
    error
  }
}
`;



const AddResidentBtn = (props) => {
const accesTokenValue = Cookies.get('userAccessToken');
const [ addResident, { loading, }] = useMutation(ADD_RESIDENT);
const [checked, setChecked] = React.useState(false)


  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };
const propertyId = props.id

const handleSubmit = (e)=>{
  e.preventDefault()
  console.log()
  var dart ={ 
    propertyId: propertyId,
    isExistingResident: checked,
    existingResidentId: existingResidentIdRef.current.ref,
    name: nameRef.current.value,
    phone: phoneRef.current.value,
    email: emailRef.current.value,
  };
  console.log(dart)
  addResident({
    variables:dart,
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  }).then((response) => {
    toaster.success("Resident added successfully.")
    // history.push(`/loader`);
    window.location.reload()

  })
  .catch((error) => {
      console.log("sdd==",error);
      toaster.danger(error.message)
  });

}

const nameRef = useRef(null);
const emailRef = useRef(null);
const phoneRef = useRef(null);
const existingResidentIdRef = useRef("");
// const typeRef = useRef(null);

  return (
    <div>

      <FieldBtn onClick={handleOpenDialog} class="waves-effect waves-light btn-flat  ">
          <i class="material-icons left">add</i>
          Add New Resident
      </FieldBtn>
      <Dialog
        // width="55%"
        isShown={isDialogOpen}
        title="Add New Resident"
        onCloseComplete={() => setIsDialogOpen(false)}
        hasFooter={false}
        hasHeader={true}
        shouldCloseOnEscapePress={false}
        shouldCloseOnOverlayClick={false}
        onCancel={() => setIsDialogOpen(false)}
      
      >
        <form onSubmit={handleSubmit}>
        
        <div className=''>
          
          <div className='row'>
             
              {!checked &&

              <div className='col s12 '>
                  <InputFieldTitleText>
                       Name
                  </InputFieldTitleText>
                  <AppInputField
                      type="text" 
                      placholder="alijames@gmail.com"
                      ref={nameRef}
                  required/> 
              </div>
              }
              {!checked &&
              <div className='col s12 '>
                  <InputFieldTitleText>
                      Email
                  </InputFieldTitleText>
                  <AppInputField
                      type="email" 
                      placholder=""
                      ref={emailRef}
                  required/> 
              </div>
              }
              {!checked &&
              <div className='col s12 '>
                  <InputFieldTitleText>
                    Phone No
                  </InputFieldTitleText>
                  <AppInputField
                      type="tel" 
                      placholder=""
                      ref={phoneRef}
                  required/> 
              </div>
              }
              {!checked &&
                <div className='col s12 '>
                  <Checkbox 
                    checked={checked}
                    onChange={e => setChecked(e.target.checked)}
                    label="Is this person an existing resident of the property?" 
                  />
                </div>
              }


             

          </div>
      </div>
        {!checked &&
        <div className='row'>
            <div className='col s12 right' style={{
                display:"flex",
                flexWrap:"wrap",
                justifyContent:"end"
            }}>
                <div className='' style={{
                    width:"100px",
                    padding:"8px "
                }}>
                    <AppInputFieldBtnCancel 
                    className='btn btn-flat center p-2'
                    style={{
                        background:"transparent !important"
                    }} 
                    onClick={() => setIsDialogOpen(false)}
                  >
                        Cancel
                    </AppInputFieldBtnCancel >
                </div>
                <div className='' style={{
                    width:"120px",
                    padding:"8px "
                }}>
                    <AppInputFieldBtn type='submit' className='' disabled={loading}>
                        Add
                    </AppInputFieldBtn>
                </div>
            </div>
        </div>
        }
      </form>

      {checked && 
        <div className='row'>
          <SearchResident id={propertyId}/>
          <div className='col s12 '>
              <Checkbox 
                checked={checked}
                onChange={e => setChecked(e.target.checked)}
                label="Is this person an existing resident of the property?" 
              />
            </div>
        </div>
      }

      </Dialog>
    </div>
  );
};



function SearchResident(props) {
  const [searchText, setSearchText] = useState(null);
  const [show, setShow] = useState(false);
  const searchTextRef = useRef(null);

  const handleInputChange = (event) => {
      setShow(false)
      const f = searchTextRef.current.value
      if(f.length >2){
        handleSearch()
      }
  };
  const handleSearch= ()=>{
    setShow(true)
    setSearchText(searchTextRef.current.value)
}

const handleSelectionChange = (option) => {
  // onSelectionChanged(option)
  console.log("pABLO-===",option)
};
   
  return (
    <div>
       <InputFieldTitleText>
              Search resident name 
        </InputFieldTitleText>
        <AppInputField
            type="text" 
            placholder="alijames@gmail.com"
            ref={searchTextRef}
            onChange={handleInputChange}
        required/> 
         {show &&
            <SearchByResidentOrAddressBody propertyId={props.id} searchText={searchText} onSelectionChanged={handleSelectionChange}  />
          }
    </div>
  )
}

const SearchByResidentOrAddressBody = ({propertyId,searchText, onSelectionChanged }) => {
  const facilityId = Cookies.get('facilityId');
  const { loading, error, data } = useQuery(PROPERTYSEARCHBYRESIDENT, {
      variables: { 
          searchTerm: searchText,
          facilityId: facilityId
      },
  });
  
  
  if(error) return <p>Error: {error}</p>
  if(loading) return  <Spinner/>
  const datat =data.properties_searchByAddressAndResidentName;
  console.log("yyy==",datat)
    return (
      <div>  
          {datat.length>0  
              ?<div className='row'
                >
                  <div className='col s12 ' style={{
                      width:"100%",
                      border:"1px solid #D9D9D9",
                      borderRadius:"5px",
                      minHeight:"50px",
                      maxHeight:"400px",
                      overflow: "auto",
                      
                    }}> 
                      { datat.map((data)=>
                          <div style={{
                            display:"flex",
                          }}>
                            <p 

                              style={{
                                flex:"1",
                                padding:"10px 0px 10px 0px",
                                margin:"0px !important",
                                color:"#000000",
                                fontWeight:"800!important"

                              }}
                            >
                              <b>
                                {capitalizeFirstLetterOfWords(data.resident.name)}
                              </b>
                              <br/>
                              <small>{data.resident.email}</small><br/>
                              <small>{data.resident.phone}</small>
                            </p>

                            
                            <div className='' style={{
                                width:"100px",
                                marginTop:"14px"
                            }}>
                              <AddExistingResident data={{
                                "id":propertyId,
                                "residentId":data.resident.id
                              }}/>
                                
                            </div>

                          </div>
                      
                        )
                      }

                  </div>
              </div>
              :<p className='center'>Resident not found.</p>
          }

          
      </div>
    )
  }



function AddExistingResident(props) {
const propertyId = props.data.id
const residentId = props.data.residentId
const accesTokenValue = Cookies.get('userAccessToken');


const [ addResident, { loading, }] = useMutation(ADD_RESIDENT);
const handleSubmit = (e)=>{
  e.preventDefault()
  console.log(residentId)
  console.log(propertyId)

  var dart ={ 
    propertyId: propertyId,
    isExistingResident: true,
    existingResidentId: residentId,
  };
  console.log(dart)
  addResident({
    variables:dart,
    context: {
      headers: {
        Authorization: `Bearer ${accesTokenValue}`,
      },
    },
  }).then((response) => {
    toaster.success("Resident added successfully.")
    window.location.reload()

  })
  .catch((error) => {
      console.log("sdd==",error);
      toaster.danger(error.message)
  });

}
    return (
      <div>
        <AppInputFieldBtn 
          type='submit' 
          className=''
          onClick={handleSubmit}
          disabled={loading}
        >
            {loading && <center><Spinner/></center> }
            {!loading && 'Add'}
        </AppInputFieldBtn>
      </div>
    )
  }
  





const DeleteResidentIconBtn = ({propertyId,residentId}) => {
      const [isDialogOpen, setIsDialogOpen] = useState(false);
    
      const handleOpenDialog = () => {
        setIsDialogOpen(true);
      };
    // const propertyId = props.id
      console.log("==",propertyId)
      console.log("==",residentId)

      return (
        <div>
    
         
          <IconButton onClick={handleOpenDialog} icon={TrashIcon} intent="danger"  />
          <Dialog
            isShown={isDialogOpen}
            title="Remove Resident"
            onCloseComplete={() => setIsDialogOpen(false)}
            hasFooter={false}
            hasHeader={true}
            shouldCloseOnEscapePress={false}
            shouldCloseOnOverlayClick={false}
            onCancel={() => setIsDialogOpen(false)}
          
          >
            <CheckResidentRemoval residentId={residentId} propertyId={propertyId} />
          </Dialog>
        </div>
      );
    };
    
    




   
const PROPERTY_PRERESIDENT_REMOVE = gql`
  query Property_preResidentRemove($residentId: ID!, $propertyId: ID!) {
    property_preResidentRemove(residentId: $residentId, propertyId: $propertyId) {
      deleteAdvisable
      reason
    }
  }
`;
    
    const PROPERTY_RESIDENT_REMOVE = gql`
      mutation Property_removeResident($propertyId: ID!) {
        property_removeResident(propertyId: $propertyId) {
          code
          success
          error
        }
      }
    `;






function CheckResidentRemoval({ residentId, propertyId }) {
  const { loading, error, data } = useQuery(PROPERTY_PRERESIDENT_REMOVE, {
    variables: { residentId,propertyId },
  });

  if (loading) return <Spinner />;

  if (error) {
    toaster.danger(`Error: ${error.message || "An error occurred"}`);
    return <p className="center">Error: {error.message}</p>;
  }

  const { deleteAdvisable, reason } = data?.property_preResidentRemove || {};

  return (
    <div className="center">
      {deleteAdvisable ? (
        
        <div className=''>
          <i className='material-icons green-text large center'>check_circle_outline</i>
          <p>Resident can be removed.</p>
          <RemoveResidentButton propertyId={propertyId}/>
        </div>
      ) : (
        <div className=''>
          <i className='material-icons red-text large center'>info_outline</i>
          <p className='center'>Resident removal not advisable: {reason}</p>
          <RemoveResidentButton propertyId={propertyId}/>
        </div>
      )}
      <br/>
    </div>
  );
}


function RemoveResidentButton({ propertyId }) {
const history = useHistory()

  const [removeResident, { loading }] = useMutation(PROPERTY_RESIDENT_REMOVE, {
    onCompleted: (data) => {
      const { success, error } = data.property_removeResident;
      if (success) {
        toaster.success("Resident removed successfully");
        history.push(`/property`)
        window.location.reload()
      } else {
        toaster.danger(`Failed to remove resident: ${error || "Unknown error"}`);
      }
    },
    onError: (err) => {
      toaster.danger(`Mutation error: ${err.message || "An error occurred"}`);
    },
  });

  const handleRemoveResident = () => {
    removeResident({ variables: { propertyId } });
  };

  return (
    // <button onClick={handleRemoveResident} disabled={loading}>
    //   
    // </button>
    <FieldBtnDelete onClick={handleRemoveResident} disabled={loading}
       className="waves-effect waves-light btn-flat ">
        <i class="material-icons left">delete_forever</i>
        {loading ? "Removing..." : "Remove Resident"}
    </FieldBtnDelete>
  );
}


    
    // function RemoveResident({ residentId, propertyId }) {
    //   // Execute the query
    //   const { loading: loadingOne, error: errorOne, data: dataOne } = useQuery(PROPERTY_PRERESIDENT_REMOVE, {
    //     variables: { residentId },
    //   });
    
    //   // Prepare the mutation
    //   const [removeResident, { loading: loadingTwo, error: errorTwo, data: dataTwo }] = useMutation(PROPERTY_RESIDENT_REMOVE);
    
    //   // Handle the mutation and query results
    //   useEffect(() => {
    //     if (dataOne && dataOne.property_preResidentRemove.deleteAdvisable) {
    //       removeResident({ variables: { propertyId } })
    //         .then((res) => {
    //           const { success, error } = res.data.property_removeResident;
    //           if (success) {
    //             toaster.success("Resident removed successfully");
    //             setTimeout(() => {
    //               window.location.reload() // Uncomment this line to reload the page if needed
    //             }, 2000);
    //           } else {
    //             toaster.danger(`Resident could not be removed: ${error || "Unknown error"}`);
    //           }
    //         })
    //         .catch((err) => {
    //           toaster.danger(`Mutation error: ${err.message || "An error occurred"}`);
    //         });
    //     } else if (dataOne) {
    //       toaster.danger(`Removal not advisable: ${dataOne.property_preResidentRemove.reason}`);
    //     }
    //   }, [dataOne, propertyId, removeResident]);
    
    //   if (loadingOne || loadingTwo) return <center><Spinner /></center>;
    //   if (errorOne) {
    //     toaster.danger(`Query error: ${errorOne.message || "An error occurred"}`);
    //     return <p className='center'>Error1: {errorOne.message}</p>;
    //   }
    //   if (errorTwo) {
    //     toaster.danger(`Mutation error: ${errorTwo.message || "An error occurred"}`);
    //     return <p className='center' >Error2: {errorTwo.message}</p>;
    //   }
    
    //   return (
    //     <div className='center'>
    //       {dataTwo ? (
    //         <div className='center'>
    //           <h6>{dataTwo.property_removeResident.success ? "Resident removed successfully" : "Resident not removed, an error occurred."}</h6>
    //           {dataTwo.property_removeResident.error && <p>Error: {dataTwo.property_removeResident.error}</p>}
    //         </div>
    //       ) : (
    //         <p>No data to display</p>
    //       )}
    //     </div>
    //   );
    // }
    
    